import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { faBars, faEllipsisV, faEdit, faUserEdit, faAngleLeft, faRightLeft } from '@fortawesome/pro-solid-svg-icons';
import { Observable } from 'rxjs';
import { Empresa } from '../../models/cadastro/empresa';
import { DataService } from 'src/app/service/data.service';
import { EventEmitterService } from 'src/app/service/event-emitter.service';
import { AuthService } from 'src/app/service/auth.service';
import { DemoService } from 'src/app/service/demo.service';
import { ProfileService } from 'src/app/service/profile.service';
import { UsuarioService } from 'src/app/service/usuario.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'menu-app',
  templateUrl: './menu-app.component.html',
  styleUrls: ['./menu-app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MenuAppComponent implements OnInit {
  @Input() iconeLogo: any;
  @Output() clickMenu = new EventEmitter<any>();

  usuario: any;
  empresas: Empresa[] = [];
  imagem: any;
  sub: any;
  menuAberto = false;
  imageToShow: any;
  isPrimeiroAcesso: boolean = false;
  usuario$: Observable<any> = new Observable();
  iconMenu = faBars;
  iconeMenuUser = faEllipsisV;
  iconeAlterar = faEdit;
  iconeEditar = faUserEdit;
  iconeSair = faAngleLeft;
  iconeVisao = faRightLeft;
  menuCedenteSacado: boolean = false;
  visao = 'cedente' || 'sacado';
  btMenu: boolean = false;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private profileService: ProfileService,
    private demoService: DemoService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private usuarioService: UsuarioService,
    private _snackBar: MatSnackBar
  ) {}

  abreMenu() {
    EventEmitterService.get('abreMenu').subscribe((data) => {
      this.menuAberto = data;
    });

    this.menuAberto = !this.menuAberto;
    EventEmitterService.get('abreMenu').emit(this.menuAberto);
  }

  ngOnInit() {
    EventEmitterService.get('menuEstaAberto').subscribe((data) => {
      this.menuAberto = data;
      EventEmitterService.get('abreMenu').emit(this.menuAberto);
    });

    this.empresas = this.dataService.getEmpresas();

    this.getUsuario();
    this.cedenteESacado();
  }

  btMenuChange() {
    this.btMenu = true;
    this.clickMenu.emit(this.btMenu);
  }

  getEmpresas() {
    this.profileService.getAcessosEmpresas().then((ids) => {});
  }

  getCedentes() {
    this.profileService.getAcessosCedentes().then((ids) => {});
  }

  getSacados() {
    this.profileService.getAcessosSacados().then((ids) => {});
  }

  getInvestidores() {
    this.profileService.getAcessosInvestidor().then((ids) => {});
  }

  async cedenteESacado() {
    let perfisHabilitados = [];
    if (await this.profileService.temAcessoPortalCedente()) perfisHabilitados.push('cedente');
    if (await this.profileService.temAcessoPortalSacado()) perfisHabilitados.push('sacado');
    if (await this.profileService.temAcessoPortalInvestidor()) perfisHabilitados.push('investidor');

    if (perfisHabilitados.length > 1) this.menuCedenteSacado = true;
    else this.menuCedenteSacado = false;
  }

  admin() {
    this.demoService.admin().subscribe(
      (s) => console.log(s),
      (er) => console.log(er)
    );
  }

  user() {
    this.demoService.user().subscribe(
      (s) => console.log(s),
      (er) => console.log(er)
    );
  }

  teste1() {
    this.demoService.getTeste1().subscribe(
      (s) => console.log(s),
      (er) => console.log(er)
    );
  }

  teste2() {
    this.demoService.getTeste2().subscribe(
      (s) => console.log(s),
      (er) => console.log(er)
    );
  }

  getUsuario() {
    this.authService.loadUserProfile().then((u: any) => {
      this.requestOpcoesuser();
    });
  }

  getPerfil() {
    if (!this.usuario?.tipoUsuario) return '';
    return 'Visão ' + this.usuario?.tipoUsuario.toLowerCase();
  }

  createImageFromBlob(image: any) {
    if (image) {
      const unsafeImg = URL.createObjectURL(image);
      this.imageToShow = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
    } else {
      this.imageToShow = null;
    }
  }

  logout() {
    this.authService.logout();
  }

  trocarVisao() {
    this.router.navigate(['visao'], {
      queryParams: { trocarVisao: 'true' },
    });
  }

  alterarSenha() {
    //   this.router.navigate([`home/primeiro-acesso/${false}`]);
  }

  editarPerfil() {
    // this.spinner.show();
    // this.authService.getUsuario(true).subscribe((usuarioLogado) => {
    //   this.dataService.usuarioEditando = this.carregaUsuario(usuarioLogado);
    //   this.dataService.usuarioEditando.tipoEdicao = 'edicaoMenu';
    //   this.spinner.hide();
    //   this.router.navigate([`home/cadastro/usuario`]);
    // });
  }

  // carregaUsuario(usuario: Usuario) {
  //   const {
  //     ativo,
  //     configuracaoUsuario,
  //     nome,
  //     id,
  //     username,
  //     perfis,
  //     ddd,
  //     telefone,
  //     email,
  //     dataNascimento,
  //   } = usuario;

  //   const associados = usuario.associados.map((associado: any) => {
  //     const {
  //       ativo,
  //       nome,
  //       nomeCarteira,
  //       password,
  //       pkId,
  //       username,
  //       pkEmpresaPkId,
  //       pkEmpresaPkTenant,
  //     } = associado;
  //     return <UsuarioERP>{
  //       ativo,
  //       nome,
  //       nomeCarteira,
  //       password,
  //       pkId,
  //       username,
  //       pkEmpresaPkId,
  //       pkEmpresaPkTenant,
  //     };
  //   });

  //   const us: Usuario = <Usuario>{
  //     ativo,
  //     configuracaoUsuario,
  //     nome,
  //     id,
  //     username,
  //     perfis,
  //     ddd,
  //     telefone,
  //     email,
  //     dataNascimento,
  //     associados,
  //   };

  //   return us;
  // }

  requestOpcoesuser() {
    this.usuarioService
      .obterUsuarioComOpcoes()
      .then((user) => {
        this.usuario = user;
        this.visao = this.usuario.tipoUsuario == 'CEDENTE' ? 'cedente' : 'sacado';
      })
      .catch((error) => {
        console.error('error', error);
        this._snackBar.open('Ocorreu um erro, tente novamente.', 'Ok');
      });
  }
}
